module.exports = __webpack_public_path__ + "static/img/background.21f42206.svg";